import React, { useEffect, useState } from "react";
import { makeStyles, createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import { Button, InputLabel, Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton } from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { FormattedMessage } from "react-intl";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import Divider from "@material-ui/core/Divider";
import Grid from "@material-ui/core/Grid";
import { Close } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputAdornment from "@material-ui/core/InputAdornment";

const useStyles = (props) =>
    makeStyles((theme) => ({
        modalTitle: {
            backgroundColor: theme.palette.primary.main,
        },
        modalContent: {
            backgroundColor: theme.palette.primary.main,
        },
        modalActions: {
            backgroundColor: theme.palette.primary.main,
            paddingBottom: 20,
            paddingTop: 20,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
        },
        textoHeader: {
            color: theme.palette.secondary.dark,
            fontWeight: "bold",
            fontSize: "14pt",
            marginTop: "1rem",
            marginRight: 80,
        },
        texto: {
            color: theme.palette.secondary.contrastText,
            width: "80%",
            textAlign: "center",
            marginLeft: "8%",
        },
        iconClose: {
            color: theme.palette.secondary.contrastText,
            marginTop: "5px",
        },
        textItalic: {
            color: theme.palette.secondary.dark,
        },
        divider: {
            height: "8px",
            backgroundColor: theme.palette.secondary.dark,
            width: "15%",
            //marginLeft:'30%'
        },
        buttons: {
            width: 150,
            color: "#929292",
            fontSize: "12px",
            fontFamily: "Verdana Bold",
            borderRadius: 8,
            opacity: "200%",
            background: "#DFDFDF",
            paddingTop: 8,
            paddingBottom: 8,
            "&:hover": {
                background: "#DFDFDF",
            },
        },
    }));

const themeAddhuesped = createMuiTheme({
    overrides: {
        MuiOutlinedInput: {
            root: {
                color: "white",
                // Hover state
                "&:hover $notchedOutline": {
                    borderColor: "#DFDFDF",
                    border: "2px solid",
                },
                // Focused state
                "&$focused $notchedOutline": {
                    borderColor: "#DFDFDF",
                    border: "2px solid",
                },
            },
            // Default State
            notchedOutline: {
                borderColor: "#DFDFDF",
                border: "2px solid",
            },
        },
        MuiInputLabel: {
            root: {
                color: "#DFDFDF",
                "&$focused $notchedOutline": {
                    color: "#DFDFDF",
                },
            },
        },
        MuiRadio: {
            root: {
                color: "#DFDFDF !important",
            },
        },
        MuiFormLabel: {
            root: {
                color: "#DFDFDF !important",
                //fontSize: '7pt'
                "&.Mui-focused": {
                    color: "#DFDFDF",
                },
            },
        },
        MuiFormControlLabel: {
            root: {
                color: "#DFDFDF !important",
                //fontSize: '7pt'
            },
        },
        MuiButton: {
            root: {
                borderRadius: 8,
                height: 50,
                color: "#DFDFDF",
            },
        },
    },
});

export default function ModalNacionalidad(props) {
    const propscreen = {
        screen: window.screen.width,
    };
    const classes = useStyles(propscreen)();
    const dispatch = useDispatch();
    const selector = useSelector((store) => store);

    //-------------------------------------------------------------------------------
    //----------------------------ESTADOS--------------------------------------------
    //-------------------------------------------------------------------------------
    const [listadoNacionalidades, setListadoNacionalidades] = useState([]);
    const [listadoNacionalidadesBuscar, setListadoNacionalidadesBuscar] = useState([]);
    const [value, setValue] = useState("");
    const [textBuscar, setTextBuscar] = useState("");

    //-------------------------------------------------------------------------------
    //----------------------------FUNCIONES------------------------------------------
    //-------------------------------------------------------------------------------

    const handleClickCloseDialogNacionalidad = () => {
        dispatch({ type: "OPEN_DIALOG_NACIONALIDAD", data: false });
    };

    const handleClickSeleccionarNacionalidad = () => {
        if (value !== "") {
            dispatch({ type: "SELECT_NACIONALIDAD", data: value });
            dispatch({ type: "OPEN_DIALOG_NACIONALIDAD", data: false });
        }
    };

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleChangeBuscar = (e) => {
        setTextBuscar(e.target.value);
        if (e.target.value.trim() === "") {
            setListadoNacionalidadesBuscar(listadoNacionalidades);
        } else {
            let temp = [];
            for (let i = 0; i < listadoNacionalidades.length; i++) {
                if (listadoNacionalidades[i].name.toLowerCase().includes(e.target.value.toLowerCase())) temp.push(listadoNacionalidades[i]);
            }
            setListadoNacionalidadesBuscar(temp);
        }
    };

    //-------------------------------------------------------------------------------
    //--------------------------------VISTA------------------------------------------
    //-------------------------------------------------------------------------------

    useEffect(() => {
        setTextBuscar("");
        setValue("");
        setListadoNacionalidades(props.listado);
        setListadoNacionalidadesBuscar(props.listado);
    }, [props.listado]);

    return (
        <Dialog
            maxWidth="sm"
            open={(selector.user.open_modal_nacionalidad === undefined) | (selector.user.open_modal_nacionalidad === "undefined") ? false : selector.user.open_modal_nacionalidad}
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClickCloseDialogNacionalidad();
                }
            }}
            disableEscapeKeyDown={true}
            aria-labelledby="max-width-dialog-title"
            fullWidth
        >
            <DialogTitle id="max-width-dialog-title" className={classes.modalContent}>
                <Grid container>
                    <Grid item xs={12} style={{ display: "flex", flexDirection: "row", justifyContent: "end" }}>
                        <Typography className={classes.textoHeader}>
                            <FormattedMessage id="seleccione_nacionalidad" />
                        </Typography>
                        <IconButton onClick={handleClickCloseDialogNacionalidad} className={classes.iconClose}>
                            <Close />
                        </IconButton>
                    </Grid>
                    <Grid item xs={12} style={{ display: "flex", flexDirection: "row", justifyContent: "center" }}>
                        <Divider className={classes.divider} />
                    </Grid>
                </Grid>
            </DialogTitle>
            <DialogContent className={classes.modalContent}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", marginBottom: 10 }}>
                    <ThemeProvider theme={themeAddhuesped}>
                        <FormControl variant="outlined" style={{ width: "65%" }}>
                            <InputLabel htmlFor="outlined-buscar">
                                <FormattedMessage id="buscar" />
                            </InputLabel>
                            <OutlinedInput
                                id="outlined-buscar"
                                type="text"
                                value={textBuscar}
                                onChange={handleChangeBuscar}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <IconButton aria-label="toggle buscar" edge="end">
                                            <SearchIcon style={{ color: "#DFDFDF" }} />
                                        </IconButton>
                                    </InputAdornment>
                                }
                                labelWidth={40}
                            />
                        </FormControl>
                    </ThemeProvider>
                </div>
                <div style={{ marginLeft: 40 }}>
                    {listadoNacionalidades.length > 0 ? (
                        <RadioGroup aria-label="nacionalidades" name="nacionalidades" value={value} onChange={handleChange}>
                            {listadoNacionalidadesBuscar.map((item, index) => (
                                <FormControlLabel
                                    key={item.id}
                                    value={item.id}
                                    control={
                                        <Radio
                                            icon={<RadioButtonUncheckedIcon fontSize="small" />}
                                            checkedIcon={<CheckCircleOutlineIcon fontSize="small" />}
                                            name="checkedI"
                                            style={{
                                                color: "#929292",
                                            }}
                                        />
                                    }
                                    style={{
                                        borderBottomWidth: 2,
                                        borderBottomStyle: "solid",
                                        borderBottomColor: "#929292",
                                    }}
                                    label={
                                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                                            {item.flag ? <img alt="" src={item.flag} style={{ heigh: 15 }} /> : ""}
                                            <Typography style={{ color: "#929292", marginLeft: 10 }}>{item.name}</Typography>
                                        </div>
                                    }
                                />
                            ))}
                        </RadioGroup>
                    ) : (
                        ""
                    )}
                </div>
            </DialogContent>
            <DialogActions className={classes.modalActions}>
                <Button variant="contained" onClick={handleClickSeleccionarNacionalidad} className={classes.buttons}>
                    <FormattedMessage id="aplicar" />
                </Button>
            </DialogActions>
        </Dialog>
    );
}
